import { LanguageListItem } from "../../../../LanguageSelect";

export const BottomDrawerItems = () => {

	return <>
		<LanguageListItem />
	</>
}
